export const LABELS = {
  NAME: "Name",
  AREA: "Area",
  ADDRESS_LINE_1: "Address",
  ADDRESS_LINE_2: "Address Line 2",
  CITY: "City",
  STATE: "State",
  PINCODE: "Pincode",
  CONTACT_NUMBER: "Contact Number",
  EMAIL_ADDRESS: "Email Address",
  DOB: "Date of joining",
};

export const NEW_ENTRY_FIELDS = {
  NAME: "fullName",
  ADDRESS: "address",
  ADDRESS_LINE_1: "addressLine1",
  // ADDRESS_LINE_2: "addressLine2",
  CITY: "city",
  CITY_NAME: "cityName",
  STATE: "state",
  STATE_NAME: "stateName",
  PINCODE: "pincode",
  CONTACT_NUMBER: "mobileNumber",
  EMAIL_ADDRESS: "emailId",
  PARENT_EMAIL_ADDRESS: "parentsEmailId",
  PARENT_CONTACT_NUMBER: "parentsMobileNumber",
  DIVISION: "divisionId",
  SUB_DIVISION: "subdivisionId",
  GENDER: "gender",
  NATIONALITY_ID: "nationalityId",
  DATE_OF_JOINING: "dateOfJoining",
  INTRODUCED_BY_NAME: "introducerName",
  INTRODUCED_BY_EMAIL: "introducerEmail",
  INTRODUCED_BY_MOBILE_NUMBER: "introducerMobileNumber",
  INTRODUCED_BY: "introducedBy",
  COUNTRY: "countryId",
  PROFESSION: "profession",
  POSITION: "positions",
};

export const NEW_FRIEND_FIELDS = {
  NAME: "fullName",
  ADDRESS_LINE_1: "addressLine1",
  // ADDRESS_LINE_2: "addressLine2",
  CITY: "city",
  STATE: "state",
  PINCODE: "pincode",
  CONTACT_NUMBER: "mobileNumber",
  EMAIL_ADDRESS: "emailId",
  DIVISION: "divisionId",
  SUB_DIVISION: "subdivisionId",
  NATIONALITY_ID: "nationalityId",
  INTRODUCED_BY_NAME: "introducerName",
  INTRODUCED_BY_EMAIL: "introducerEmail",
  INTRODUCED_BY_MOBILE_NUMBER: "introducerMobileNumber",
  INTRODUCED_BY: "introducedBy",
  DATE_OF_BIRTH: "dateOfBirth",
  PROFESSION: "profession",
  COUNTRY: "countryId",
  PARENT_EMAIL_ADDRESS: "parentsEmailId",
  PARENT_CONTACT_NUMBER: "parentsMobileNumber",
  GENDER: "gender",
};

export const FRIEND_TRANFER_REQUEST_FIELDS = {
  FRIEND_NAME: "fullName",
  FRIEND_ID: "firendId",
  ADDRESS: "address",
  ADDRESS_LINE_1: "addressLine1",
  // ADDRESS_LINE_2: "addressLine2",
  CITY: "city",
  STATE: "state",
  PINCODE: "pincode",
  CONTACT_NUMBER: "mobileNumber",
  EMAIL_ADDRESS: "emailId",
  DIVISION: "divisionId",
  SUB_DIVISION: "subdivisionId",
  DATE_OF_JOINING: "dateOfJoining",
  PARENT_EMAIL_ADDRESS: "parentsEmailId",
  PARENT_CONTACT_NUMBER: "parentsMobileNumber",
  INTRODUCED_BY_NAME: "introducerName",
  INTRODUCED_BY_MOBILE_NUMBER: "introducerMobileNumber",
  INTRODUCED_BY_EMAIL: "introducerEmail",
};

export const MEMBER_TRANSFER_REQUEST_FIELDS = {
  MEMBER_NAME: "fullName",
  MEMBER_ID: "memberId",
  ADDRESS: "address",
  ADDRESS_LINE_1: "addressLine1",
  // ADDRESS_LINE_2: "addressLine2",
  CITY: "city",
  STATE: "state",
  PINCODE: "pincode",
  CONTACT_NUMBER: "mobileNumber",
  EMAIL_ADDRESS: "emailId",
  DIVISION: "divisionId",
  SUB_DIVISION: "subdivisionId",
  DATE_OF_JOINING: "dateOfJoining",
  PARENT_EMAIL_ADDRESS: "parentsEmailId",
  PARENT_CONTACT_NUMBER: "parentsMobileNumber",
  INTRODUCED_BY_NAME: "introducerName",
  INTRODUCED_BY_MOBILE_NUMBER: "introducerMobileNumber",
  INTRODUCED_BY_EMAIL: "introducerEmail",
};

export const ORGANIZATION_STRUCTURE_FIELDS = {
  AREA: "areaId",
  CLUSTER: "clusterId",
  ZONE: "zoneId",
  REGION: "regionId",
  CHAPTER: "chapterId",
  DISTRICT: "districtId",
  BLOCK: "blockId",
};

export const INITIATOR_ORGANIZATION_STRUCTURE_FIELDS = {
  AREA: "initiatorAreaId",
  // CLUSTER: "initiatorclusterId",
  CLUSTER: "initiatorClusterId",
  ZONE: "initiatorZoneId",
  REGION: "initiatorRegionId",
  CHAPTER: "initiatorChapterId",
  DISTRICT: "initiatorDistrictId",
  BLOCK: "initiatorBlockId",
};

export const TARGET_ORGANIZATION_STRUCTURE_FIELDS = {
  AREA: "targetAreaId",
  // CLUSTER: "targetclusterId",
  CLUSTER: "targetClusterId",
  ZONE: "targetZoneId",
  REGION: "targetRegionId",
  CHAPTER: "targetChapterId",
  DISTRICT: "targetDistrictId",
  BLOCK: "targetBlockId",
};

export const CHANGE_FRIEND_ENTRY_FIELDS = {
  NAME: "fullName",
  ADDRESS_LINE_1: "addressLine1",
  // ADDRESS_LINE_2: "addressLine2",
  CITY: "city",
  STATE: "state",
  PINCODE: "pincode",
  CONTACT_NUMBER: "mobileNumber",
  EMAIL_ADDRESS: "emailId",
  DIVISION: "divisionId",
  SUB_DIVISION: "subdivisionId",
  INRODUCER_NAME: "introducedBy",
  INTRODUCER_CONTACT_NUMBER: "introducerContactNumber",
  INTRODUCER_EMAIL_ADDRESS: "introducerEmailAddress",
  GENDER: "gender",
  NATIONALITY_ID: "nationalityId",
  DATE_OF_JOINING: "dateOfJoining",
  INTRODUCED_BY_NAME: "introducerName",
  INTRODUCED_BY_EMAIL: "introducerEmail",
  INTRODUCED_BY_MOBILE_NUMBER: "introducerMobileNumber",
  AREA: "areaId",
  CLUSTER: "clusterId",
  ZONE: "zoneId",
  REGION: "regionId",
  CHAPTER: "chapterId",
  DISTRICT: "districtId",
  BLOCK: "blockId",
};

export const FAMILY_FIELDS = {
  FAMILY_NAME: "familyName",
  ADDRESS_LINE_1: "familyAddress",
  CITY: "city",
  STATE: "state",
  PINCODE: "pincode",
  MEMBER_ID: "memberId",
  RELATION_TYPE: "relationType",
  RELATED_MEMBER_ID: "relatedMemberId",
};

export const MEMBER_PROFILE_CREATE = {
  NAME: "fullName",
  ADDRESS_LINE_1: "addressLine1",
  // ADDRESS_LINE_2: "addressLine2",
  CITY: "city",
  STATE: "state",
  PINCODE: "pincode",
  DATE_OF_BIRTH: "dateOfBirth",
  CONTACT_NUMBER: "mobileNumber",
  EMAIL_ADDRESS: "emailId",
  DIVISION: "divisionId",
  NATIONALITY_ID: "nationalityId",
  SUB_DIVISION: "subdivisionId",
  SUB_DIVISION_F: "subDivisionId",
  INTRODUCED_BY_NAME: "introducerName",
  INTRODUCED_BY_EMAIL: "introducerEmail",
  INTRODUCED_BY_MOBILE_NUMBER: "introducerMobileNumber",
  INTRODUCED_BY: "introducedBy",
  BLOCK: "blockId",
  BLOCK_NAME: "blockName",
  PROFESSION: "profession",
  PROFESSIONAL_SERVICE: "professionalServiceGroup",
  GOHONZON: "gohonzon",
  REMARK: "remark",
  PARENT_EMAIL_ADDRESS: "parentsEmailId",
  PARENT_CONTACT_NUMBER: "parentsMobileNumber",
  UNIVERSITY_ID: "universityId",
  COLLEGE: "collegeName",
  EDUCATIONQUALIFICATION: "educationalQualification",
  COMPANYNAME: "companyName",
  OCCUPATION: "occupation",
  DESIGNATION: "designation",
  DIVISION_NAME: "divisionName",
  SUB_DIVISION_NAME: "subDivisionName",
  AREA_NAME: "areaName",
  CLUSTER_NAME: "clusterName",
  ZONE_NAME: "zoneName",
  REGION_NAME: "regionName",
  CHAPTER_NAME: "chapterName",
  DISTRICT_NAME: "districtName",
  DISTRICT: "districtId",
};

export const GOHONZON_OKATAKI_FIELDS = {
  DURATION_OF_PRACTICE: "durationOfPractice",
  REGULAR_GONGYO_DAIMOKU: "regularGongyoDaimoku",
  PERMISSION_TO_RECEIVE: "permissionToReceive",
  PLACE_OF_ENSHRINED: "placeOfEnshrined",
};

export const GOHONZON_OKATAKI_INTERVIEW_FIELDS = {
  REGION_IDS: "regionIds",
  APPORVED_BY_ALL_COMMITE_MEMBERS: "approvedByAllCommitteeMembers",
};

export const GOHONZON_OMAMORI_FIELDS = {
  JOB_POSITION: "jobPosition",
  NATURE_OF_WORK: "natureOfWork",
  COMPANY_NAME: "companyName",
  REGULAR_PRACTICE: "regularPractice",
  GOHONZON_MEMBERSHIP: "gohonzonMembership",
  DAYS_AWAY_FROM_HOME: "daysAwayFromHome",
  ACTIVE_PARTICIPATION: "activeParticipation",
};

export const GOHONZON_SUBMISSION = {
  DURATION_OF_PRACTICE: "durationOfPractice",
  REGULAR_GONGYO_DAIMOKU: "regularGongyoDaimoku",
  PERMISSION_TO_RECEIVE: "permissionToReceive",
  PLACE_OF_ENSHRINED: "placeOfEnshrined",
  DAYS_AWAY_FROM_HOME: "daysAwayFromHome",
  REGULAR_PRACTICE: "regularPractice",
  GOHONZON_MEMBERSHIP: "gohonzonMembership",
  ACTIVE_PARTICIPATION: "activeParticipation",
  RECOMMENDED_BY_CHAPTERCHIEF: "recommendedByChapterChief",
  RECOMMENDED_BY_REGIONCHIEF: "recommendedByRegionChief",
  RECOMMENDED_BY_ZONECHIEF: "recommendedByZoneChief",
  APPORVED_BY_ALL_COMMITE_MEMBERS: "approvedByAllCommitteeMembers",
  CONFERRAL_DATE: "conferralDate",
  CANCELLED_BY: "cancelledBy",
  ALLOTED_AT: "allotedAt",
  ALLOTED_BY: "allotedBy",
  COLLECTED_AT: "collectedAt",
  MARRIAGE_WITH_GOHONZON_MEMBER: "marriageWithGohonzonMember",
  NOT_PRACTICING: "notPracticing",
  LIVING_WITH_FAMILY_HAVING_GOHONZON:
    "startedLivingWithTheFamilyAlreadyHavingGohonzon",
  GOHONZON_DAMAGED_BY_MEMBER_HIMSELF_OR_HERSELF:
    "gohonzonDamagedByMemberHimselfOrHerself",
  DEMISE: "demise",
  EXCHANGING_OLD_GOHONZON: "exchangingOldGohonzon",
  OTHER: "other",
  GOHONZON_DAMAGED_BY_FAMILY_MEMBER: "gohonzonDamagedByFamilyMember",

  MEMBER_NAME: "fullName",
  MEMBER_ID: "memberId",
  APPLICATION_DATE: "appliedAt",
  CONFERRED_BY: "conferredBy",
  GOHONZON_TYPE: "gohonzonType",
  CONFERRED_DATE: "conferredDate",
  REMARK: "remark",
  SUB_TYPE: "type",
  SUB_STATUS: "status",
  SUB_DELIVERY_MODE: "deliveryMode",
  EXPIRY_DATE: "endAt",
  START_DATE: "startAt",
  SUBSCRIPTION_NUMBER: "subscriptionNumber",
  VOLUME: "volumeId",
};

export const APPOINTMENT_ENTRY = {
  MEMBER_AGE: "memberAge",
  MEMBER_ID: "memberId",
  REMARK: "remark",
  MEMBER_RELATIONSHIP: "memberRelationship",
  DATE_RECEVING_GHONZON: "dateofreceivingGhonzon",
  NUMBER_OF_SHAKUBUL: "numberofshakubul",
  NO_OF_HOME_VISITS_WEEK: "numberOfHomeVisitsWeek",
  PARTICIPATION_YEAR: "participationYear",
  IS_BSG_MEMBER: "isBsgMember",
  IS_GHONZON_RECEIVED: "isGhonzonRecived",
  IS_BSG_STUDY_EXAMINATION_CLEAR: "isBsgExamClear",
  IS_DUAL: "isDual",
  VC_SUBSCRIPTION: "IsVcSubscribed",
  IS_PROG_ATTENDED: "isProgramAttended",
  MADE_EFFORTS_TOWARDS: "isEffortsMade",
  HAS_BEEN_BLOCK_CHEIF: "hasBeenBlockChief",
  ATTENDING_MEETING: "attendingMeeting",
  YEARS_OF_ACTIVE_PRACTICE: "yearsOfActivePractice",
  RC_FOR_DISTRICT_CHIEF: "rcForDisTrictChief",
  REGULAR_PRACTICE: "regularPractice",
  GOHONZON_MEMBERSHIP: "gohonzonMembership",
  ACTIVE_PARTICIPATION: "activeParticipation",
  RECOMMENDED_BY_CHAPTERCHIEF: "recommendedByChapterChief",
  RECOMMENDED_BY_REGIONCHIEF: "recommendedByRegionChief",
  RECOMMENDED_BY_ZONECHIEF: "recommendedByZoneChief",
  APPORVED_BY_ALL_COMMITE_MEMBERS: "approvedByAllCommitteeMembers",
  DOING_GONGYO_AND_DAIKOMU: "doingGongyoAndDaimokuRegularly",
  POSITION_HELD_IN_YOUTH_DIVISION: "positionHeldInYouthDivision",
  HAS_BEEN_CHAPTER_CHEIF: "hasBeenChapterChief",
  ATTENDING_BSG_MEETING_INCLUDING_NHR_GOSHO:
    "attendingBsgMeetingIncludingNhrGosho",
  ACTIVELY_PARTICIPATING_LEADER_MEETING: "activelyParticipatingLeaderMeeting",
  CLEARED_THE_INTRODUCTORY_LEVEL_EXAMINATION_ENTRANCE_EXAM:
    "clearedTheIntroductoryLevelExaminationEntranceExam",
  OWN_GOHONZON_OR_FAMILY_GOHONZON: "ownGohonzonOrFamilyGohonzon",
  HAS_BEEN_REGION_CHEIF: "hasBeenRegionChief",
  ACTIVELY_SUPPORTING_LEADERS_MEETING: "activelySupportingLeadersMeeting",
  CLEARED_THE_INTRODUCTORY_LEVEL_EXAMINATION:
    "clearedTheIntroductoryLevelExamination",
  HAS_BEEN_DISTRICT_CHIEF: "hasBeenDistrictChief",
};

export const APPOINTMENT_MEMBER_SEARCH = {
  SEARCH_MEMBER: "searchMember",
  APPLICATION_TYPE: "applicationType",
  APPLICATION_FOR: "applicationFor",
  CHEIF_SI: "cheifSi",
  DIVISION: "divisionId",
};

export const APPOINTMENT_CYCLE_FIELDS = {
  STRUCTURE_LEVEL: "structureLevel",
  MODULE: "module",
  START_DATE: "startDate",
  END_DATE: "endDate",
  ACTIVE: "active",
  CREATED_AT: "createdAt",
  CREATED_BY: "createdBy",
  CREATED_BY_NAME: "createdByName",
};

export const EXAMINATION_CYCLE_FIELD = {
  EXAMINATION_LEVEL: "examLevel",
  EXAM_DATE: "examDate",
};

export const SPLIT_SEARCH_FIELDS = {
  AREA: "areaId",
  CLUSTER: "clusterId",
  ZONE: "zoneId",
  REGION: "regionId",
  CHAPTER: "chapterId",
  DISTRICT: "districtId",
};

export const SPLIT_EDIT_FORM_FIELDS = {
  NAME: "name",
  STATS_INCHARGE: "statsIncharge",
  DEPUTY_STATS_INCHARGE: "deputyStatsIncharge",
  MEN_DIVISION: "menDivion",
  WOMEN_DIVISION: "womenDivision",
  YOUNG_WOMEN_DIVSION: "youngWomenDivision",
  YOUNG_MEN_DIVSION: "youngMenDivision",
  DEPUTY_MEN_DIVISION: "deputyMenDivion",
  DEPUTY_WOMEN_DIVISION: "deputyWomenDivision",
  DEPUTY_YOUNG_WOMEN_DIVSION: "deputyYoungWomenDivision",
  DEPUTY_YOUNG_MEN_DIVSION: "deputyYoungMenDivision",
};

export const RELATION_FIELDS = {
  RELATED_MEMBER: "name",
  MEMBER_AGE: "age",
  RELATION_TYPE: "relationType",
  MEMBER_OR_NOT: "memberOrNot",
  REMARK: "remarks",
};

export const UHG_SEARCH_FIELDS = {
  LEVEL: "structureLevel",
  AREA: "areaId",
  CLUSTER: "clusterId",
  ZONE: "zoneId",
  REGION: "regionId",
  CHAPTER: "chapterId",
  DISTRICT: "districtId",
  BLOCK: "blockId",
};

export const FILE_UPLOAD_FIELDS = {
  DOCUMENT_NAME: "name",
  CATEGORY: "category",
  START_DATE: "startDate",
  END_DATE: "endDate",
  ACTIVE: "active",
  CREATED_AT: "createdAt",
  CREATED_BY: "createdBy",
  CREATED_BY_NAME: "createdByName",
};
